module.exports = __webpack_public_path__ + "static/media/star-small-orange.63d79477.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/star-small-orange.svg
// module id = 1019
// module chunks = 0